import cogoToast from "cogo-toast";
import { CREATE_ACTIVITY_FROM_EMPTY, UPDATE_ACTIVITY_STATUS } from "../apollo/mutations";
import { GET_ACTIVITIES_WITH_UPDATE_VERSION_USING_GUIDS } from "../apollo/queries";
import moment from "moment";

export const createActivityMutation = async (model, client) => {
  try {
    let response = await client.mutate({ mutation: CREATE_ACTIVITY_FROM_EMPTY, variables: { model } });
    let stringify = JSON.stringify(response);
    let parsed = JSON.parse(stringify);
    const resp = parsed?.data.createActivityFromEmptyActivity?.activity

    if (parsed == undefined) {
      return 'FAIL'
    }
    return resp
  } catch (error) {
  
    return 'FAIL'
  }
}

export const runFastPublish = async (_guid, _updateVersion, _toActivityStatusId, _fromActivityStatusId, _workflowId, note, client, setStatuForwardResponse) => {
  let model = {
    updateVersion: _updateVersion,

    activityStatusLogNote: note,


    fromActivityStatusId: _fromActivityStatusId,

    guid: _guid,

    toActivityStatusId: _toActivityStatusId,

    workflowId: _workflowId
  };
  try {
    let response = await client.mutate({
      mutation: UPDATE_ACTIVITY_STATUS,
      variables: { model }
    });

    let stringify = JSON.stringify(response);
    let parsed = JSON.parse(stringify);
    setStatuForwardResponse(parsed)


    if (response.errors != null) {
      cogoToast.error("Statü güncellemesi başarısız oldu.");

      setStatuForwardResponse(undefined)
    } else {
      cogoToast.success("Statü güncellendi.");
    }
  } catch (e) {
    setStatuForwardResponse(undefined)
    cogoToast.error("Statü güncellemesi başarısız oldu.");
  }

};

export const getActivityForUpdateVersion = async (salesPersonGuid, parentGuid, client, setUpdateVersion, _activityChildGuid, setActivityChildParent) => {

  try {

    let response = await client.mutate({
      mutation: GET_ACTIVITIES_WITH_UPDATE_VERSION_USING_GUIDS,
      variables: {
        activityGuid: parentGuid
      }
    });
    let stringify = JSON.stringify(response);
    let parsed = JSON.parse(stringify);
    let resp = parsed.data.activities.edges[0].node
    //there are some more data and can be but just need updateVersion
    const newUpdateVersionChild = resp.childActivities.find(element => element.guid == _activityChildGuid)
    setActivityChildParent(resp)
    setUpdateVersion(newUpdateVersionChild.updateVersion)

  } catch (error) {
  }
}



export const modelUpdateMutationCreator = (updateVersion,typeGuid,_activityChildGuid,emptyActivityStatementList) => {
  let model = {
    updateVersion: updateVersion,
    activityTypeGuid: typeGuid,
    activityGuid: _activityChildGuid,
    notes: "",
    activityStatements: emptyActivityStatementList,
    planDateTime:
      moment(new Date()).format("YYYY-MM-DD") +
      " " +
      moment().format("HH:mm"),
    planEndDateTime:
      moment(new Date()).add(5,'days').format("YYYY-MM-DD") +
      " " +
      moment().format("HH:mm"),
  };

  return model;
}